import React from 'react';

import RsModal from '@Pages/RetroSynthesis/components/RsModal';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import './PlacementModal.scss';

function PlacementModal({ isShown, setIsShown, children }) {
  const selfClose = () => {
    setIsShown(false);
  };

  return (
    <RsModal showBackfrop showModal={isShown}>
      <GeneralDialogLayout
        layoutType="nothing"
        size="xl"
        selfClose={selfClose}
        closeBtn={false}
        contentClassName="rx-flex-column-container project-route-conditions-placement-modal">
        {children}
      </GeneralDialogLayout>
    </RsModal>
  );
}

export default PlacementModal;
